export default "__VITE_ASSET__GN9ZQ1XK__"